<template>
    <div class="input-group search-bar">
        <span class="input-group-text bi bi-search"></span>
        <input type="text" class="form-control" placeholder="Search" aria-label="Search" v-model="keyword">
    </div>
</template>

<script>
export default {
    name: "SearchBar",
    mounted() {
        // reset keyword on each mount
        this.keyword = '';
    },
    computed: {
        keyword: {
            get: function () {
                return this.$store.getters['filter/keyword']
            },
            set: function (value) {
                this.$store.commit('filter/SET_KEYWORD', value)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.input-group.search-bar {
    border: none;
    padding: 20px 18px;
    font-size: 20px;
    border-bottom: 1px solid var(--color-gray-light);

    .input-group-text {
        border: none;
        /* padding-top: 20px; */
        font-size: 20px;
        /* padding-left: 30px; */
        margin-top: 15px;
        background: none;
    }

    input {
        font-size: 24px;
        letter-spacing: 0.045em;
        border: none;
        background: none;
        margin: 15px auto auto;
        padding: 0 0 0 20px;
    }
}
</style>
